import { AUTH_TOKEN_KEY } from '../constants';
export const clearSessionStorage = () => {
    sessionStorage.clear();
};
export const setSessionStorageAuthToken = (token) => {
    sessionStorage.setItem(AUTH_TOKEN_KEY, token);
};
export const getSessionStorageAuthToken = () => {
    try {
        return sessionStorage.getItem(AUTH_TOKEN_KEY);
    }
    catch (e) {
        // logger.error(e);
    }
    return null;
};
//# sourceMappingURL=sessionStorage.js.map